import * as THREE from 'three';

// ── Visual effects system ──
export class EffectsManager {
  constructor(scene) {
    this.scene = scene;
    this.sparks = [];
    this.trails = [];
  }

  // Create spark burst at collision point
  spawnCollisionSparks(position, color1, color2) {
    const count = 15;
    for (let i = 0; i < count; i++) {
      const geo = new THREE.SphereGeometry(0.03 + Math.random() * 0.04, 4, 4);
      const mat = new THREE.MeshBasicMaterial({
        color: Math.random() > 0.5 ? color1 : color2,
        transparent: true, opacity: 1,
      });
      const spark = new THREE.Mesh(geo, mat);
      spark.position.copy(position);
      spark.position.y += 0.3;

      const speed = 2 + Math.random() * 4;
      const angle = Math.random() * Math.PI * 2;
      const upSpeed = 1 + Math.random() * 3;
      spark.userData.vel = new THREE.Vector3(
        Math.cos(angle) * speed,
        upSpeed,
        Math.sin(angle) * speed
      );
      spark.userData.life = 0.5 + Math.random() * 0.3;
      spark.userData.age = 0;

      this.scene.add(spark);
      this.sparks.push(spark);
    }
  }

  // Create spin trail ring
  addTrailRing(position, color, radius) {
    const geo = new THREE.RingGeometry(radius - 0.02, radius + 0.02, 32);
    const mat = new THREE.MeshBasicMaterial({
      color: color,
      transparent: true, opacity: 0.4,
      side: THREE.DoubleSide,
    });
    const ring = new THREE.Mesh(geo, mat);
    ring.position.copy(position);
    ring.position.y += 0.1;
    ring.rotation.x = -Math.PI / 2;
    ring.userData.life = 0.3;
    ring.userData.age = 0;

    this.scene.add(ring);
    this.trails.push(ring);
  }

  // Burst explosion
  spawnBurst(position) {
    // Flash sphere
    const flashGeo = new THREE.SphereGeometry(1, 16, 16);
    const flashMat = new THREE.MeshBasicMaterial({
      color: 0xffaa00,
      transparent: true, opacity: 0.8,
    });
    const flash = new THREE.Mesh(flashGeo, flashMat);
    flash.position.copy(position);
    flash.userData.life = 0.5;
    flash.userData.age = 0;
    flash.userData.isBurst = true;
    this.scene.add(flash);
    this.sparks.push(flash);

    // Many sparks
    this.spawnCollisionSparks(position, 0xffaa00, 0xff4400);
    this.spawnCollisionSparks(position, 0xffdd00, 0xff6600);
  }

  update(dt) {
    // Update sparks
    for (let i = this.sparks.length - 1; i >= 0; i--) {
      const s = this.sparks[i];
      s.userData.age += dt;

      if (s.userData.vel) {
        s.position.x += s.userData.vel.x * dt;
        s.position.y += s.userData.vel.y * dt;
        s.position.z += s.userData.vel.z * dt;
        s.userData.vel.y -= 10 * dt; // gravity
      }

      if (s.userData.isBurst) {
        s.scale.setScalar(1 + s.userData.age * 4);
      }

      const t = s.userData.age / s.userData.life;
      s.material.opacity = Math.max(0, 1 - t);

      if (s.userData.age >= s.userData.life) {
        this.scene.remove(s);
        s.geometry.dispose();
        s.material.dispose();
        this.sparks.splice(i, 1);
      }
    }

    // Update trails
    for (let i = this.trails.length - 1; i >= 0; i--) {
      const t = this.trails[i];
      t.userData.age += dt;
      const progress = t.userData.age / t.userData.life;
      t.material.opacity = Math.max(0, 0.4 * (1 - progress));
      t.scale.setScalar(1 + progress * 0.5);

      if (t.userData.age >= t.userData.life) {
        this.scene.remove(t);
        t.geometry.dispose();
        t.material.dispose();
        this.trails.splice(i, 1);
      }
    }
  }

  dispose() {
    [...this.sparks, ...this.trails].forEach(obj => {
      this.scene.remove(obj);
      obj.geometry.dispose();
      obj.material.dispose();
    });
    this.sparks = [];
    this.trails = [];
  }
}
